import { TcsApiUtils } from '@/utils/tcsApiUtils'
import { getCurrentDateTime } from '@/utils/format'
import parseDeviceModel from '@/utils/parseDeviceModel'

const BASE_URL = process.env.VUE_APP_PRIVACY_RECORD_URL
// 开发环境下使用代理前缀，避免跨域
const getPrivacyRecordUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return '/consultive'
  }
  console.log(BASE_URL)
  return BASE_URL
}

function getProductCode(): string {
  return process.env.VUE_APP_TCSAPI_PRODUCT_CODE || ''
}

// 协议版本信息（4.3 协议更新推送查询 响应）
export interface AgreementVersionRes {
  id: string
  consultativeCode: string
  consultativeName: string
  productCode: string
  productName: string
  presentationUrl: string
  version: string
  consultativePresentation: string
}

// 协议内容信息（4.2 根据协议编码获取协议内容 响应）
export interface AgreementContentRes {
  productCode: string
  consultativeCode: string
  consultativeName: string
  presentationUrl: string
  consultativePresentation?: string // 协议正文（接口可能不返回，需通过 presentationUrl 查看）
  consultativeLabel?: string
  version?: string // 协议版本（接口可能不返回）
  createByName?: string
  createTime?: string
  updateByName?: string
  updateTime?: string
}

// 4.3 协议更新推送查询 - 获取最新协议版本
// 注意：前端需控制请求调用成功次数，每天不超过5次
export const getAgreementVersion = (consultativeCode: string): Promise<AgreementVersionRes> => {
  const url = getPrivacyRecordUrl() + '/consultativeManagement/queryLatest'
  return TcsApiUtils.sendSignedRequest(url, {
    consultativeCode,
    productCode: getProductCode()
  }).then((res: any) => {
    if (res.code === 1 && res.data) {
      return res.data as AgreementVersionRes
    }
    throw new Error(res.msg || '获取协议版本失败')
  })
}

// 4.2 根据协议编码获取协议内容
export const getAgreementContent = (consultativeCode: string): Promise<AgreementContentRes> => {
  const url = getPrivacyRecordUrl() + '/consultativeManagement/queryConsultativeByCode'
  return TcsApiUtils.sendSignedRequest(url, {
    consultativeCode,
    productCode: getProductCode()
  }).then((res: any) => {
    if (res.code === 1 && res.data) {
      return res.data as AgreementContentRes
    }
    throw new Error(res.msg || '获取协议内容失败')
  })
}

// 4.1 用户阅读协议记录 - 记录Cookie同意操作
export const submitCookieConsentLog = (params: {
  consultativeName: string
  consultativeCode: string
  consultativeVersion: string // 当前 Cookie 协议版本
  operationType: string // '登录前' | '登录' | '更新弹窗'
}): Promise<void> => {
  const url = getPrivacyRecordUrl() + '/consultativeOperationRecord/saveConsultativeOperationRecord'
  const deviceModel = parseDeviceModel(navigator.userAgent)
  const data = {
    productCode: getProductCode(),
    list: [
      {
        consultativeName: params.consultativeName,
        consultativeReadTime: getCurrentDateTime(),
        consultativeCode: params.consultativeCode,
        consultativeVersion: params.consultativeVersion,
        operationType: params.operationType,
        deviceId: 'H5',
        deviceModel: deviceModel || ''
      }
    ]
  }
  return TcsApiUtils.sendSignedRequest(url, data).then((res: any) => {
    if (res.code !== 1) {
      throw new Error(res.msg || '记录协议阅读失败')
    }
  })
}
